import React, { useState, useEffect } from "react";
import styled from "styled-components";
import bannerImg from "../../assets/homeAssets/bannerImg.png";
import mobileBannerImg from "../../assets/homeAssets/mobileBannerImg.png";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Banner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to handle link clicks
  const openBooking = (url) => {
    window.open(url, "_blank");
    setIsModalOpen(false);
  };

  return (
    <Container>
      <div className="banner-content">
        <div className="gradient-overlay"></div>
        <div className="text-content">
          <h1 className="title">
            Willkommen bei <br /> <span>Era Aesthetics</span> <br /> <a>&</a>{" "}
            Academy
          </h1>
          <p className="subtitle">
            Dein NISV zertifiziertes Studio für dauerhafte Haarentfernung,
            professionelle Gesichtsbehandlungen und zertifizierte Schulungen.
            Wir verbinden modernste Technologien mit individueller Betreuung –
            für sichtbare Ergebnisse und höchste Qualität. Deine Schönheit.
            Unsere Expertise.
          </p>

          {/* Changed Link to a button to trigger the Modal */}
          <button className="shop-btn" onClick={() => setIsModalOpen(true)}>
            JETZT TERMIN BUCHEN
          </button>
        </div>
      </div>

      {/* --- BOOKING SELECTION MODAL --- */}
      <AnimatePresence>
        {isModalOpen && (
          <ModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsModalOpen(false)}
          >
            <ModalContent
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside
            >
              <CloseBtn onClick={() => setIsModalOpen(false)}>&times;</CloseBtn>
              <h3>Termin buchen</h3>
              <p>Bitte wählen Sie Ihre bevorzugte Buchungsplattform:</p>

              <ButtonGroup>
                <PlatformBtn
                  onClick={() =>
                    openBooking(
                      "https://buchung.treatwell.de/ort/era-aesthetics-academy/",
                    )
                  }
                >
                  <span>Treatwell</span>
                  <small>Schnelle Online-Buchung</small>
                </PlatformBtn>

                <PlatformBtn
                  onClick={() =>
                    openBooking(
                      "https://beautinda.de/artist/glAjRxw9FkUTkPh98ZNpnvDTdqV2",
                    )
                  }
                >
                  <span>Beautinda</span>
                  <small>Alternative Buchung</small>
                </PlatformBtn>
              </ButtonGroup>
            </ModalContent>
          </ModalOverlay>
        )}
      </AnimatePresence>
    </Container>
  );
};

// --- New Styled Components for Modal ---

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(90, 82, 72, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

const ModalContent = styled(motion.div)`
  background: #fdfcfb;
  padding: 3rem;
  border-radius: 30px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  position: relative;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);

  h3 {
    font-family: "Playfair Display", serif;
    font-size: 2rem;
    color: #5a5248;
    margin-bottom: 1rem;
  }

  p {
    color: #6d6357;
    margin-bottom: 2rem;
    line-height: 1.5;
  }
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 2rem;
  color: #5a5248;
  cursor: pointer;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const PlatformBtn = styled.button`
  background: white;
  border: 1px solid rgba(109, 99, 87, 0.2);
  padding: 20px;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    font-size: 1.2rem;
    font-weight: 600;
    color: #5a5248;
    margin-bottom: 4px;
  }

  small {
    color: #857869;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
  }

  &:hover {
    background: #6d6357;
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
    span,
    small {
      color: white;
    }
  }
`;
const Container = styled.div`
  width: 94%;
  height: 85vh;
  position: relative;
  overflow: hidden;
  margin: 8em 5em 7em 5em;
  border-radius: 40px;

  .banner-content {
    width: 100%;
    height: 100%;
    /* Default background for desktop/tablet (>500px) */
    background-image: url(${bannerImg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 7%;

    /* Add animation on load */
    opacity: 0;
    transform: scale(1.05);
    animation: bannerReveal 1s ease-out forwards;
    animation-delay: 0.3s;

    @keyframes bannerReveal {
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
  }

  .gradient-overlay {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 50%;

    /* Main gradient that fully fades to transparent */
    background: linear-gradient(
      90deg,
      rgba(241, 235, 228, 0.95) 0%,
      rgba(241, 235, 228, 0.85) 10%,
      rgba(241, 235, 228, 0.75) 20%,
      rgba(241, 235, 228, 0.65) 30%,
      rgba(241, 235, 228, 0.55) 40%,
      rgba(241, 235, 228, 0.45) 50%,
      rgba(241, 235, 228, 0.35) 60%,
      rgba(241, 235, 228, 0.25) 70%,
      rgba(241, 235, 228, 0.15) 80%,
      rgba(241, 235, 228, 0.05) 90%,
      rgba(241, 235, 228, 0) 100%
    );

    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    mask-image: linear-gradient(90deg, black 0%, black 70%, transparent 100%);
    -webkit-mask-image: linear-gradient(
      90deg,
      black 0%,
      black 70%,
      transparent 100%
    );
    z-index: 1;

    /* Animation for the blur effect */
    animation: blurReveal 1.2s ease-out forwards;
    animation-delay: 0.5s;
    opacity: 0;

    @keyframes blurReveal {
      to {
        opacity: 1;
      }
    }

    /* Optional: Add a subtle radial gradient on top for more organic feel */
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(
        ellipse at left center,
        rgba(241, 235, 228, 0.4) 0%,
        rgba(241, 235, 228, 0.2) 30%,
        transparent 60%
      );
      pointer-events: none;
    }
  }

  .text-content {
    position: relative;
    z-index: 2;
    max-width: 800px;
    color: #6d6357;
    margin-left: 4%;
    margin-bottom: 8em;

    /* Text animation */
    opacity: 0;
    transform: translateX(-30px);
    animation: textReveal 0.8s ease-out forwards;
    animation-delay: 1s;

    @keyframes textReveal {
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .title {
      font-size: 4vw;
      font-weight: 500;
      margin-bottom: 25px;
      line-height: 1.1;
      text-shadow: 3px 3px 6px rgba(241, 235, 228, 0.4);
      color: #5a5248;
      position: relative;
      z-index: 2;
      font-family: "The Seasons", cursive;
      span {
        color: #857869;
      }
      /* a {
        font-family: "Montserrat";
        font-style: italic;
      } */
    }
    .subtitle {
      margin-bottom: 35px;
      line-height: 1.7;
      color: #6d6357;
      text-shadow: 1px 1px 3px rgba(241, 235, 228, 0.6);
      font-weight: 500;
      font-size: 1rem;
    }
    @media (max-width: 500px) {
      .subtitle {
      }
    }

    .shop-btn {
      background: #6d6357;
      color: white;
      border: none;
      padding: 16px 40px;
      font-size: 1.2rem;
      font-weight: 600;
      border-radius: 35px;
      cursor: pointer;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 6px 20px rgba(109, 99, 87, 0.4);
      font-family: "Poppins", cursive;
      position: relative;
      overflow: hidden;

      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 0;
        height: 0;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
        transform: translate(-50%, -50%);
        transition:
          width 0.6s,
          height 0.6s;
      }

      &:hover {
        background: #5a5248;
        transform: translateY(-4px);
        box-shadow: 0 10px 25px rgba(109, 99, 87, 0.5);

        &::after {
          width: 300px;
          height: 300px;
        }
      }

      &:active {
        transform: translateY(-1px);
        box-shadow: 0 5px 15px rgba(109, 99, 87, 0.4);
      }
      @media (max-width: 450px) {
        font-size: 58px;
      }
    }
  }

  @media (max-width: 1800px) {
    margin: 8em 2em 7em 2em;
    .text-content {
      margin-left: 4%;
    }
  }

  @media (max-width: 1600px) {
    .text-content {
      align-self: flex-start;
      margin-top: 15%;
    }
  }

  /* Tablet Styles (830px and below) */
  @media (max-width: 830px) {
    width: 90%;
    height: 80vh;
    margin: 6em auto;
    border-radius: 30px;

    .banner-content {
      padding: 0;
      align-items: flex-start;
      justify-content: center;
      text-align: center;
    }

    .gradient-overlay {
      width: 100%;
      height: 50vh;
      background: linear-gradient(
        to bottom,
        rgba(241, 235, 228, 0.95) 0%,
        rgba(241, 235, 228, 0.85) 20%,
        rgba(241, 235, 228, 0.7) 40%,
        rgba(241, 235, 228, 0.4) 70%,
        rgba(241, 235, 228, 0.1) 90%,
        transparent 100%
      );
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      mask-image: linear-gradient(
        to bottom,
        black 0%,
        black 80%,
        transparent 100%
      );
      -webkit-mask-image: linear-gradient(
        to bottom,
        black 0%,
        black 80%,
        transparent 100%
      );

      &::before {
        background: radial-gradient(
          ellipse at center top,
          rgba(241, 235, 228, 0.5) 0%,
          rgba(241, 235, 228, 0.3) 30%,
          transparent 70%
        );
      }
    }

    .text-content {
      margin-left: 0;
      margin-top: 10vh;
      text-align: center;
      max-width: 90%;
      padding: 0 20px;

      .title {
        font-size: 4.5rem;
        text-align: center;
      }

      .subtitle {
        font-size: 1.3rem;
        text-align: center;
        padding: 0 10px;
        margin-bottom: 30px;
      }

      .shop-btn {
        width: 80%;
        max-width: 300px;
        padding: 15px 35px;
        font-size: 0.8em;
        display: block;
        margin: 0 auto;
      }
    }
  }

  /* Mobile Styles (500px and below) - NEW BACKGROUND IMAGE */
  @media (max-width: 500px) {
    width: 95%;
    height: 87vh;
    border-radius: 40px;

    .banner-content {
      /* Switch to mobile background image */
      background-image: url(${mobileBannerImg});
      background-size: cover;
      background-position: center;
      padding: 0;
      align-items: flex-start;
      justify-content: center;
    }
  }

  @media (max-width: 600px) {
    margin-top: 6vh;
    .text-content {
      .title {
        font-size: 2.8em;
      }
      .subtitle {
        font-size: 0.8em;
        line-height: 1.4;
      }
    }
  }

  /* Small Mobile Styles (360px and below) */
  @media (max-width: 420px) {
    height: 75vh;
    border-radius: 15px;

    .text-content {
      margin-top: 10vh;
      padding: 0 10px;

      .title {
        font-size: 11vw;
        margin-bottom: 15px;
      }

      .subtitle {
        font-size: 0.75rem;
        margin-bottom: 20px;
      }

      .shop-btn {
        width: 85%;
        padding: 12px 25px;
        font-size: 0.75rem;
      }
    }

    .gradient-overlay {
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
    }
  }

  /* Landscape Orientation for Mobile */
  @media (max-height: 500px) and (max-width: 500px) {
    height: 95vh;

    .text-content {
      margin-top: 5vh;

      .title {
        font-size: 3.8rem;
      }

      .subtitle {
        font-size: 0.9rem;
        margin-bottom: 20px;
      }

      .shop-btn {
        padding: 10px 25px;
        font-size: 0.7rem;
      }
    }
  }
`;

export default Banner;
